import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-02e68efa")

_pushScopeId("data-v-02e68efa")
const _hoisted_1 = { class: "nav-menu" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, null, -1)
const _hoisted_5 = { class: "nav-menu__content" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SearchBlock = _resolveComponent("SearchBlock")
  const _component_MenuDesktopList = _resolveComponent("MenuDesktopList")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("button", {
      class: "btn nav-menu__btn",
      onClick: _cache[1] || (_cache[1] = $event => ($setup.isActive = !$setup.isActive))
    }, [
      _hoisted_2,
      _hoisted_3,
      _hoisted_4
    ]),
    _createVNode("div", {
      class: ["nav-menu__body", { 'nav-menu__body--active': $setup.isActive }]
    }, [
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_SearchBlock),
        _createVNode(_component_MenuDesktopList, {
          class: "main-header__menu",
          onChangeRoute: _cache[2] || (_cache[2] = $event => ($setup.isActive = false))
        })
      ])
    ], 2)
  ]))
})